(() => {
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const menuPanel = document.querySelector('[data-mobile-menu]');

  if (menuToggle && menuPanel) {
    menuToggle.addEventListener('click', () => {
      const expanded = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!expanded));
      menuPanel.hidden = expanded;
      document.documentElement.classList.toggle('mobile-menu-open', !expanded);
    });
  }

  document.querySelectorAll('[data-shop-menu-toggle]').forEach((toggle) => {
    const item = toggle.closest('.site-nav__item');
    if (!item) return;

    toggle.addEventListener('click', (event) => {
      event.stopPropagation();
      const expanded = toggle.getAttribute('aria-expanded') === 'true';

      document.querySelectorAll('[data-shop-menu-toggle]').forEach((otherToggle) => {
        otherToggle.setAttribute('aria-expanded', 'false');
        otherToggle.closest('.site-nav__item')?.classList.remove('is-open');
      });

      toggle.setAttribute('aria-expanded', String(!expanded));
      item.classList.toggle('is-open', !expanded);
    });
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('.site-nav__item--has-menu')) return;

    document.querySelectorAll('[data-shop-menu-toggle]').forEach((toggle) => {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.closest('.site-nav__item')?.classList.remove('is-open');
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('[data-shop-menu-toggle]').forEach((toggle) => {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.closest('.site-nav__item')?.classList.remove('is-open');
    });
  });

  const path = window.location.pathname.toLowerCase();
  let activeRoute = '';

  if (path.endsWith('/') || path.endsWith('/_preview/') || path.endsWith('/index.html') || path.endsWith('/home.html')) {
    activeRoute = 'home';
  } else if (path.includes('services')) {
    activeRoute = 'services';
  } else if (path.includes('media')) {
    activeRoute = 'media';
  } else if (path.includes('pricing') || path.includes('subscription')) {
    activeRoute = 'pricing';
  } else if (path.includes('about')) {
    activeRoute = 'about';
  }

  if (activeRoute) {
    document.querySelectorAll('[data-nav-link]').forEach((link) => {
      link.classList.toggle('is-active', link.getAttribute('data-nav-link') === activeRoute);
    });
  }

  document.querySelectorAll('[data-product-form]').forEach((wrapper) => {
    const form = wrapper.querySelector('form');
    const optionsRoot = wrapper.querySelector('[data-product-options]');
    const variantSelect = wrapper.querySelector('[data-product-variant-select]');
    const price = wrapper.closest('.product-basic')?.querySelector('[data-product-price]');
    const button = wrapper.querySelector('[data-add-to-cart]');
    const buttonText = wrapper.querySelector('[data-add-to-cart-text]');

    if (!form || !variantSelect || !optionsRoot) return;

    let variants = [];
    try {
      variants = JSON.parse(optionsRoot.getAttribute('data-product-variants') || '[]');
    } catch (error) {
      return;
    }

    const updateSelectedVariant = () => {
      const selectedOptions = Array.from(optionsRoot.querySelectorAll('[data-product-option]'))
        .sort((a, b) => Number(a.dataset.optionPosition || 0) - Number(b.dataset.optionPosition || 0))
        .map((option) => option.querySelector('input:checked')?.value)
        .filter(Boolean);

      const variant = variants.find((item) => {
        return item.options && item.options.every((value, index) => value === selectedOptions[index]);
      });

      if (!variant) {
        if (button) button.disabled = true;
        if (buttonText) buttonText.textContent = 'Unavailable';
        return;
      }

      const selectedOption = Array.from(variantSelect.options).find((option) => option.value === String(variant.id));
      variantSelect.value = String(variant.id);

      if (selectedOption && price) {
        price.textContent = selectedOption.dataset.price || price.textContent;
      }

      if (button) button.disabled = !variant.available;
      if (buttonText) buttonText.textContent = variant.available ? 'Add to cart' : 'Sold out';
    };

    optionsRoot.addEventListener('change', updateSelectedVariant);
    updateSelectedVariant();
  });

  document.querySelectorAll('[data-nk-media-page]').forEach((page) => {
    const carousel = page.querySelector('[data-nk-carousel]');
    const track = page.querySelector('[data-nk-carousel-track]');
    const dotsRoot = page.querySelector('[data-nk-carousel-dots]');
    const slides = track ? Array.from(track.children) : [];

    if (carousel && track && dotsRoot && slides.length) {
      let current = 0;
      let autoTimer;
      let startX = 0;

      const dots = slides.map((slide, index) => {
        const dot = document.createElement('button');
        dot.className = `nk-car-dot${index === 0 ? ' active' : ''}`;
        dot.type = 'button';
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
        dot.addEventListener('click', () => {
          goToSlide(index);
          resetAuto();
        });
        dotsRoot.appendChild(dot);
        return dot;
      });

      const getVideo = (index) => slides[index]?.querySelector('video');

      const goToSlide = (index) => {
        const leavingVideo = getVideo(current);
        if (leavingVideo) leavingVideo.pause();

        current = ((index % slides.length) + slides.length) % slides.length;
        track.style.transform = `translateX(-${current * 100}%)`;

        dots.forEach((dot, dotIndex) => {
          dot.classList.toggle('active', dotIndex === current);
        });

        const arrivingVideo = getVideo(current);
        if (arrivingVideo) {
          arrivingVideo.play().catch(() => {});
          clearInterval(autoTimer);
        }
      };

      const moveSlide = (direction) => {
        goToSlide(current + direction);
        resetAuto();
      };

      const resetAuto = () => {
        const activeVideo = getVideo(current);
        if (activeVideo && !activeVideo.paused) return;

        clearInterval(autoTimer);
        autoTimer = setInterval(() => {
          goToSlide(current + 1);
        }, 5000);
      };

      page.querySelector('[data-nk-carousel-prev]')?.addEventListener('click', () => {
        moveSlide(-1);
      });

      page.querySelector('[data-nk-carousel-next]')?.addEventListener('click', () => {
        moveSlide(1);
      });

      carousel.addEventListener('touchstart', (event) => {
        startX = event.touches[0].clientX;
      }, { passive: true });

      carousel.addEventListener('touchend', (event) => {
        const deltaX = event.changedTouches[0].clientX - startX;
        if (Math.abs(deltaX) > 40) {
          moveSlide(deltaX < 0 ? 1 : -1);
        }
      }, { passive: true });

      resetAuto();
    }

    page.querySelectorAll('[data-nk-role-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.getAttribute('data-nk-role-tab');

        page.querySelectorAll('[data-nk-role-tab]').forEach((item) => {
          item.classList.toggle('active', item === tab);
        });

        page.querySelectorAll('[data-nk-role-panel]').forEach((panel) => {
          panel.classList.toggle('active', panel.getAttribute('data-nk-role-panel') === target);
        });
      });
    });

    page.querySelectorAll('[data-nk-faq-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const answer = button.nextElementSibling;
        const wasOpen = button.classList.contains('open');

        page.querySelectorAll('[data-nk-faq-toggle]').forEach((item) => {
          item.classList.remove('open');
        });

        page.querySelectorAll('.nk-faq-a').forEach((item) => {
          item.classList.remove('open');
        });

        if (!wasOpen) {
          button.classList.add('open');
          answer?.classList.add('open');
        }
      });
    });
  });

  document.querySelectorAll('[data-testimonial-tab]').forEach((tab) => {
    tab.addEventListener('click', () => {
      const group = tab.closest('[data-testimonials]');
      const target = tab.getAttribute('data-testimonial-tab');
      if (!group || !target) return;

      group.querySelectorAll('[data-testimonial-tab]').forEach((item) => {
        item.classList.toggle('is-active', item === tab);
      });

      group.querySelectorAll('[data-testimonial-panel]').forEach((panel) => {
        panel.hidden = panel.getAttribute('data-testimonial-panel') !== target;
      });
    });
  });

})();
